import React, { useState } from 'react';
import { Input } from 'reactstrap';
import './PasswordInput.scss';

// Reusable password field with a show/hide toggle.
// Forwards every prop to reactstrap's Input. Any children (e.g. a floating
// <Label>) are rendered right after the input so the sibling selectors that
// power the floating-label styling keep working.
const PasswordInput = ({ children, ...props }) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <div className="position-relative password-input-wrap">
            <Input {...props} type={showPassword ? 'text' : 'password'} />
            {children}
            <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(prev => !prev)}
                tabIndex={-1}
            >
                <span className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'} text-white-50`} />
            </button>
        </div>
    );
};

export default PasswordInput;
